const L = {
  name: "Star",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.0004 0.763916L15.6671 8.09731L22.9637 9.3134L17.6009 15.272L19.5255 22.8671L12.005 19.1196L4.64079 22.8652L6.40808 15.2812L1.03711 9.3134L8.3337 8.09731L12.0004 0.763916ZM12.0004 5.23605L9.66709 9.90266L4.96368 10.6866L8.5927 14.7188L7.56368 19.1347L11.9958 16.8804L16.516 19.1329L15.3999 14.728L19.0371 10.6866L14.3337 9.90266L12.0004 5.23605Z" fill="currentColor"/>
</svg>
  `
};
export {
  L as Star
};
